<template>
  <b-container>
    <b-form-group :disabled="changes_disabled">
      <b-card>
        <b-form-group>
          <label>
            <b> {{ $t('table_chosen') }} </b>
          </label>
          <b-form-select v-model="table" :options="table_options" />
        </b-form-group>
      </b-card>

      <b-card :header="$t('metavariables_listing')">
        <b-list-group>
          <lazy-list-display-y
            :nb="existing_metavariables.length"
            class="synaplus-cosmo-h-480"
          >
            <template #default="{ nby, height, initialized }">
              <b-list-group-item
                v-if="initialized"
                :key="nby"
                :style="height"
                >{{ existing_metavariables[nby] }}</b-list-group-item
              ><b-list-group-item v-else :key="nby">&nbsp;</b-list-group-item>
            </template>
          </lazy-list-display-y>
        </b-list-group>
      </b-card>

      <b-card class="mt-3" :header="$t('metavariables_definition')">
        <b-form-group>
          <togglable-code-editor
            v-model="metavariables_formula"
            :columns="existing_metavariables"
            :disabled="changes_disabled"
          />
        </b-form-group>
      </b-card>
    </b-form-group>
  </b-container>
</template>

<script>
import _ from 'lodash'

import { BasicTableInfoEntity } from '@/components/object_model.js'

import TogglableCodeEditor from '@/components/togglable_code_editor.vue'
import LazyListDisplayY from '@/components/lazy_list_display_y.vue'

import { dict_from_frozendict, extended_dict_forEach } from '@/utils.js'

import { global_brick_mixin } from '@/components/mixin.js'

// *****************************************************************************

export default {
  name: 'BrickMetavariables',
  components: {
    TogglableCodeEditor,
    LazyListDisplayY,
  },
  mixins: [global_brick_mixin],
  data() {
    return {
      table: -1,
      metavariables_formula: '',
    }
  },
  computed: {
    existing_metavariables() {
      let parent_brick =
        (this.tables_undeleted['tables'] || {})[this.table] || {}
      let res = new Set()
      let dict = parent_brick.last_poids_build_cache || {}
      extended_dict_forEach(dict, (metavars, poid) => {
        res.add(...Object.keys(dict_from_frozendict(metavars)))
      })
      res = Array.from(res)
      return res
    },
    adapted_data() {
      let entry_table_id = []
      if (this.table !== -1) {
        let parent_info_entity_type = new BasicTableInfoEntity()
        parent_info_entity_type.uid = this.table
        entry_table_id.push(parent_info_entity_type)
      }
      let adapted = {
        uid: this.brick_id,
        parents_info: entry_table_id,
        metavariables_formula: this.metavariables_formula,
      }

      _.assignIn(adapted, this.description_name)

      return adapted
    },
  },
  watch: {
    cur_brick: {
      immediate: true,
      handler(nv) {
        this.metavariables_formula = nv.metavariables_formula
        this.table = (nv.parents_info[0] || {}).uid || -1
      },
    },
  },
}
</script>
